import { useStyles } from './styles'
const SiteStatus = (props) => {
  const { status } = props
  const classes = useStyles()
  return <div className={classes.layout}>{status}</div>
}
export default SiteStatus
